import { render, staticRenderFns } from "./InviteAttendeeContainer.vue?vue&type=template&id=3ecdd828&scoped=true"
import script from "./InviteAttendeeContainer.vue?vue&type=script&lang=js"
export * from "./InviteAttendeeContainer.vue?vue&type=script&lang=js"
import style0 from "./InviteAttendeeContainer.vue?vue&type=style&index=0&id=3ecdd828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdd828",
  null
  
)

export default component.exports